import { createReducer } from 'utils/redux';
import { fromJS } from 'immutable';
import initialState from './initialState';
import * as actionTypes from './actionTypes';
import { createPropertyObject } from 'modules/App/utils/helpers';

const mapPropertyObjects = (propertyObjects) =>
  propertyObjects.map(createPropertyObject).filter((object) => object);

const stateField = (isDefault) => (isDefault ? 'available' : 'other');

const onPropertyObjects = (state, { payload: { isDefault } }) =>
  state
    .setIn([stateField(isDefault), 'loading'], true)
    .setIn([stateField(isDefault), 'error'], null);

const onPropertyObjectsSuccess = (state, { payload: { data, isDefault } }) =>
  state
    .setIn([stateField(isDefault), 'data'], fromJS(mapPropertyObjects(data)))
    .setIn([stateField(isDefault), 'loading'], false);

const onPropertyObjectsError = (state, { payload }) => state.set('error', fromJS(payload));

export default createReducer(initialState, {
  [actionTypes.PROPERTY_OBJECTS]: onPropertyObjects,
  [actionTypes.PROPERTY_OBJECTS_SUCCESS]: onPropertyObjectsSuccess,
  [actionTypes.PROPERTY_OBJECTS_FAILURE]: onPropertyObjectsError,
});
